import React from 'react';
import { CSSProperties } from 'styled-components';

interface LogoProps {
  alt?: string;
  style?: CSSProperties;
}

const Logo: React.FC<LogoProps> = ({ alt = 'app-logo', style = {} }) => (
  <img alt={alt} src={require('assets/images/logo.svg')} style={style} />
);

export default Logo;
